var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarryGoods = function SvgCarryGoods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.649 3.516v19.035a3.81 3.81 0 0 1-3.807 3.807H2.905V14.205c1.39 1.66 3.514 2.685 5.88 2.636 1.929-.049 3.661-.781 4.954-2.026.586-.488 1.074-1.122 1.465-1.806.683-1.17 1.073-2.537 1.024-3.953a7.56 7.56 0 0 0-2.586-5.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M40.973 26.358v5.71a5.72 5.72 0 0 1-5.71 5.711h-1.904a3.81 3.81 0 0 0-3.807-3.807 3.81 3.81 0 0 0-3.806 3.807h-7.614a3.81 3.81 0 0 0-3.807-3.807 3.81 3.81 0 0 0-3.807 3.807H8.615a5.72 5.72 0 0 1-5.71-5.71v-5.71h20.937a3.81 3.81 0 0 0 3.807-3.808V9.227h3.514c1.366 0 2.635.732 3.318 1.928l3.246 5.686h-2.465c-1.049 0-1.903.854-1.903 1.903v5.71c0 1.05.854 1.904 1.903 1.904z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.325 41.586a3.81 3.81 0 0 0 3.807-3.807 3.81 3.81 0 0 0-3.807-3.807 3.81 3.81 0 0 0-3.806 3.807 3.81 3.81 0 0 0 3.806 3.807M29.552 41.586a3.81 3.81 0 0 0 3.807-3.807 3.81 3.81 0 0 0-3.807-3.807 3.81 3.81 0 0 0-3.806 3.807 3.81 3.81 0 0 0 3.806 3.807M40.973 22.551v3.807h-5.71a1.906 1.906 0 0 1-1.904-1.903v-5.71c0-1.05.854-1.904 1.904-1.904h2.464zM16.229 9.056a7.25 7.25 0 0 1-1.025 3.953c-.39.684-.879 1.318-1.464 1.806-1.294 1.245-3.026 1.977-4.954 2.026-2.367.048-4.49-.977-5.881-2.636a8.5 8.5 0 0 1-.708-.927 7.35 7.35 0 0 1-1.195-3.88A7.62 7.62 0 0 1 3.735 3.37a7.68 7.68 0 0 1 4.71-1.782 7.5 7.5 0 0 1 5.197 1.904 7.56 7.56 0 0 1 2.587 5.54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.638 9.3 1.928 1.83 3.978-3.856"
  })));
};
export default SvgCarryGoods;